import { connect } from "react-redux";
import AddIncentive from "./addIncentive";
import { bindActionCreators } from "redux";
import { getSalesSites,getLeadCommertialDetails,saveSalesIncentive,getSeniorBeneficiary,
    getEditableData,getHeadBeneficiary,getCalculatedIncentiveAmount } from "services/redux/salesIncentive/action";

const mapStateToProps = (state) => ({
    incentiveSites: state.SalesIncentiveReducer.incentiveList,
    commertialDetails: state.SalesIncentiveReducer.commertialDetails,
    beneficiarySenior: state.SalesIncentiveReducer.getBeneficiarySenior,
    editData: state.SalesIncentiveReducer.getEditIncentiveData,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    getSalesSites,
    getLeadCommertialDetails,
    saveSalesIncentive,
    getSeniorBeneficiary,
    getEditableData,
    getHeadBeneficiary,
    getCalculatedIncentiveAmount,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(AddIncentive);
